<template>
  <div class="h-dvh !bg-pitch-black text-total-white">
    <TopNavbar />

    <div class="overflow-y-auto max-h-full pb-[100px]">
      <!-- Header -->
      <header class="flex items-center justify-between px-4 py-4 pb-2 mb-6">
        <div class="flex items-center gap-2" @click="goBack">
          <!-- Back Icon -->
          <button class="text-prime-golden text-lg">
            <img
              class="w-6 h-6"
              src="@/assets/images/left-chevron.svg"
              alt="Back Button"
            />
          </button>
          <h1 v-if="!route.query.from" class="text-xl text-prime-golden">
            All Instructions
          </h1>
        </div>
        <!-- Edit & Delete Icons -->
        <div class="flex gap-4">
          <button @click="editInstructions" class="text-prime-golden text-sm text-md">
            <img
              src="@/assets/images/edit-pen.svg"
              class="mr-1 fa"
              alt="Edit"
              width="12"
              height="12"
            />
            <span class="underline underline-offset-4">edit</span>
          </button>
          <!-- <button @click="deleteInstruction" class="text-total-white hover:text-red-400">
            <i class="fas fa-trash-alt"></i>
          </button> -->
        </div>
      </header>

      <!-- Instruction Title -->
      <!-- Instruction Title -->
      <div
        class="flex w-full justify-end items-center gap-4 px-5"
        :class="{ 'opacity-50': isDeleting }"
      >
        <div class="text-center w-[80%] md:flex-1">
          <h2 class="text-2xl font-bold">{{ instructionTitle }}</h2>
          <!-- Default text added here -->
          <span
            v-if="isDefault"
            class="inline-block text-sm font-semibold my-2 whitespace-nowrap text-prime-golden bg-dark-grey rounded-md px-2 py-1"
          >
            default
          </span>
          <div
            class="text-ash-grey flex w-full justify-center text-center"
            :class="{ 'opacity-50': isDeleting }"
          >
            <p class="text-lg font-semibold">
              <span>Instructions ID: </span>
              <span>{{ instructionId }}</span>
            </p>
          </div>
          <p class="text-sm text-gray-400 mt-1">
            last updated at {{ parseDate(instructionUpdatedAt) }}
          </p>
        </div>
        <div class="flex justify-center" @click="deleteInstructions">
          <img src="@/assets/images/trash-icon.svg" alt="Trash Icon" class="w-6 h-6" />
        </div>
      </div>

      <!-- Instructions ID -->
      <!--<div class="mt-8 text-ash-grey flex px-5" :class="{ 'opacity-50': isDeleting }">
        <p class="text-lg font-semibold">
          <span class="">Instructions ID: </span>
          <span class="">{{ instructionId }}</span>
        </p>
      </div>-->

      <!-- Rendered Instructions -->
      <div class="mt-8 px-5" :class="{ 'opacity-50': isDeleting }">
        <div class="flex items-center justify-between gap-4 mb-2">
          <h3 class="text-2xl font-semibold">Instructions</h3>
          <div
            class="flex items-center text-prime-golden gap-2 text-sm"
            @click="forkInstructions"
          >
            <div class="text-prime-golden font-semibold text-lg cursor-pointer">fork</div>
            <img class="w-3" src="../../assets/images/fork-icon.svg" />
          </div>
        </div>
        <vue3-markdown-it
          class="flex flex-col items-start text-left prose prose-slate prose-invert mt-4"
          :source="markdownContent"
          :typographer="true"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import TopNavbar from "@/components/TopNavbar.vue";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Vue3MarkdownIt from "vue3-markdown-it"; // Markdown renderer library
import { useInstructionStore } from "@/stores/instruction"; // Import the function
import { parseDate } from "@/misc/util";

const router = useRouter();
const route = useRoute();
const instructionId = route.params.id;
const instructionTitle = ref("...");
const instructionUpdatedAt = ref("...");
const markdownContent = ref("");
const instructionStore = useInstructionStore();
const isDeleting = ref(false);
const isDefault = ref(false);

// Fetch instruction on component mount
onMounted(async () => {
  console.log("IN id:", instructionId);
  const instruction = await instructionStore.fetchInstructionById(instructionId);
  console.log("IN:", instruction);
  markdownContent.value = instruction.content; // Assuming the fetched instruction has a 'content' property
  instructionTitle.value = instruction.name;
  instructionUpdatedAt.value = instruction.date_updated;
  isDefault.value = instruction.is_default;
});

// Navigation functions
const goBack = () => {
  if (route.query.from && route.query.from[0] == "activation") {
    router.push({ name: "ViewActivationPage", params: { id: route.query.from[1] } });
  } else {
    router.push({ name: "InstructionsPage" }); // Navigate back to instructions list
  }
};

const editInstructions = () => {
  router.push({ name: "EditInstructionPage", params: { id: instructionId } });
};

const forkInstructions = () => {
  router.push({ name: "CreateInstructionsPage", query: { id: instructionId } });
};

const deleteInstructions = async () => {
  isDeleting.value = true;
  await instructionStore.deleteInstruction(instructionId);
  await instructionStore.fetchInstructions();
  router.push({ name: "InstructionsPage" });
  isDeleting.value = false;
};
</script>

<style scoped>
::v-deep ol {
  list-style: decimal; /* Ensure ordered lists have numbers */
  margin-left: 1rem; /* Add indentation */
  padding-left: 1rem;
}

::v-deep li {
  margin-bottom: 0.5rem; /* Space between list items */
}
</style>
